export default __webpack_public_path__ + "static/interior-1026456_1920-99febcb89fead91e1186f1f603ada7ab.png";